// @ts-nocheck
import { Controller } from '@hotwired/stimulus';
import { V1_GET_JOBS_AGENT, AGENT_SEARCH_PATH } from '@/constant/routers/path';

export default class extends Controller {
  static targets = [
    'form',
    'modal',
    'items',
    'prefectures',
    'cities',
    'prefectureChildren',
    'itemOccupationChecked',
    'itemPrefectureChecked',
    'jobCount',
  ];

  connect() {
    this.onSearchCountJob();
  }

  onSaveOccupation(event) {
    const $itemChecked = this.itemOccupationCheckedTarget;
    let contentHTML = '';
    this.itemsTargets.map(item => {
      if (item.querySelector('input').checked) {
        contentHTML += this.onSaveItem(event, item);
      }
    });
    $itemChecked.innerHTML = contentHTML;
    this.onSearchCountJob();
  }

  onSavePrefecture(event) {
    const $itemChecked = this.itemPrefectureCheckedTarget;
    let contentHTML = '';
    this.prefecturesTargets.map(item => {
      if (item.querySelector('input').checked) {
        contentHTML += this.onSaveItem(event, item);
      }
    });
    $itemChecked.innerHTML = contentHTML;
    this.onSearchCountJob();
  }

  onSaveItem(e, item) {
    let tag = '';
    if (item.querySelector('input').checked) {
      const label = item.querySelector('.form-check-label').textContent;
      const id = item.querySelector('input').value;
      tag =
        "<span class='badge bg-light border text-dark fw-normal size-12 lh-12 p-3'> " +
        label +
        "<button class='btn-close btn-close-primary size-10 ms-2 color-primary' type='button' data-action='click->root-modal#onRemove' data-root-modal-checkbox-param='" +
        e.params.attribute +
        '_' +
        id +
        "'></button></span>";
    }

    return tag;
  }

  onRemove(event) {
    event.target.parentNode.remove();
    document.getElementById(event.params.checkbox).checked = false;
    this.onSearchCountJob();
  }

  onSearchCountJob() {
    const form = new FormData(this.formTarget);
    const formData = new FormData();
    this._getFormDataSearchCondition(form, formData);
    // URLSearchParamsオブジェクトを作成
    const params = new URLSearchParams();

    // 収入IDから実際の金額（万円単位）への変換マップ
    const incomeMap = {
      1: 150,
      2: 200,
      3: 250,
      4: 300,
      5: 350,
      6: 400,
      7: 450,
      8: 500,
      9: 550,
      10: 600,
      11: 650,
      12: 700,
      13: 750,
      14: 800,
      15: 850,
      16: 900,
      17: 950,
      18: 1000,
      19: 1100,
      20: 1200,
      21: 1300,
      22: 1400,
      23: 1500,
      24: 1600,
      25: 1700,
      26: 1800,
      27: 1900,
      28: 2000,
      29: 2500,
      30: 3000,
      31: 3500,
      32: 4000,
      33: 4500,
      34: 5000,
      35: null,
    };

    const wageRange = [null, null];
    for (const [key, value] of formData.entries()) {
      if (key === 'wage_min' && value) {
        const amount = incomeMap[value] || value;
        wageRange[0] = amount;
      } else if (key === 'wage_max' && value) {
        const amount = incomeMap[value] || value;
        wageRange[1] = amount;
      } else if (key === 'job_types[]' && value) {
        params.append('filter[have_hrc_job_types_any][]', value);
      } else if (key === 'prefectures[]' && value) {
        params.append('filter[with_prefecture][]', value);
      } else if (value) {
        params.append(key, value);
      }
    }
    if (wageRange[0] || wageRange[1]) {
      params.append('filter[with_wage_range][]', wageRange[0]);
      params.append('filter[with_wage_range][]', wageRange[1]);
    }

    params.append('include[]', 'corporation');
    params.append('include[]', 'prefectures');
    params.append('include[]', 'hrc_skills');
    params.append('include[]', 'hrc_job_types');
    params.append('include[]', 'corporation.corporation_industries');

    params.append('sort', '-publication_date_senavi');
    params.append('page[size]', 0); // カウント値を取るだけなのでページサイズを0にする（パフォーマンス改善）
    params.append('page[number]', 1);

    const queryString = params.toString();
    const url = V1_GET_JOBS_AGENT + '?' + queryString;

    Rails.ajax({
      type: 'GET',
      url,
      dataType: 'json',
      success: response => {
        const {
          data: {
            meta: { total_records },
          },
        } = response;
        this.updateJobCount(this.jobCountTarget, total_records);
      },
      error: error => {
        this.updateJobCount(this.jobCountTarget, 0);
      },
    });
  }

  onSearchCondition(event) {
    event.preventDefault();
    const form = new FormData(this.formTarget);
    const formData = new FormData();
    this._getFormDataSearchCondition(form, formData);

    formData.append('include[]', 'corporation');
    formData.append('include[]', 'prefectures');
    formData.append('include[]', 'hrc_skills');
    formData.append('include[]', 'hrc_job_types');
    formData.append('include[]', 'corporation.corporation_industries');

    const queryString = new URLSearchParams(formData).toString();
    const url = AGENT_SEARCH_PATH + '&' + queryString;

    window.location.href = url;
  }

  updateJobCount = (element, number) => {
    let upto = 0;
    const jump = Math.floor(number / 100) + 1;
    const counts = setInterval(() => {
      upto += jump;
      if (upto > number) {
        upto = number;
      }
      element.textContent = upto;
      if (upto === number) {
        clearInterval(counts);
      }
    }, 20);
  };

  getOccupationIds(form) {
    return form.getAll('occupation_ids');
  }

  getPrefectureIds(form) {
    return form.getAll('prefecture_ids');
  }

  getCityIds(form, prefectures) {
    let cityIds = [];
    prefectures.forEach(item => {
      cityIds = cityIds.concat(form.getAll('prefecture_' + item + '_city'));
    });
    return cityIds;
  }

  getAnnualIncome(form) {
    const minIncome = form.get('roots_index_form[annual_min_income_id]');
    const maxIncome = form.get('roots_index_form[annual_max_income_id]');

    return { min_income: minIncome, max_income: maxIncome };
  }

  onDisableCity(event) {
    const citiyItems = document.getElementsByClassName(`parent_${event.target.id}`);
    const prefectureChecked = event.target.checked;
    Array.from(citiyItems).forEach(item => {
      if (prefectureChecked) {
        item.disabled = false;
      } else {
        item.disabled = true;
      }
    });
  }

  _getFormDataSearchCondition(form, formData) {
    const occupations = this.getOccupationIds(form) || [];
    const prefectures = this.getPrefectureIds(form) || [];
    const cities = this.getCityIds(form, prefectures) || [];
    const annualIncome = this.getAnnualIncome(form) || [];
    occupations.forEach(occupation => formData.append('job_types[]', occupation));
    prefectures.forEach(prefecture => formData.append('prefectures[]', prefecture));
    cities.forEach(city => formData.append('cities[]', city));
    if (annualIncome.min_income != '') {
      formData.append('wage_min', annualIncome.min_income);
    }

    if (annualIncome.max_income != '') {
      formData.append('wage_max', annualIncome.max_income);
    }
  }
}
